// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-no-important */
.SHvlbAoTXLEUoP {
  display: flex;
}
.SHvlbAoTXLEUoP .s00FC5WW2kgJuX {
  display: inline-block;
  flex: 0 0 auto;
  align-self: center;
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-size: cover;
}
.SHvlbAoTXLEUoP .SSF2Wm8KNx5F75 {
  display: block;
  align-self: center;
  margin-left: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SHvlbAoTXLEUoP .SSF2Wm8KNx5F75 .zAAtIAmzhzCZbJ {
  display: block;
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SHvlbAoTXLEUoP .SSF2Wm8KNx5F75 .lTxCPJSvD119b1 {
  display: block;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SpyrBk9DQyDOXb {
  background-color: var(--ds-background-selected, #e9f2ff) !important;
}
.GFKWAI6QJVd94m {
  background-color: var(--ds-background-selected, #e9f2ff) !important;
  color: var(--ds-icon-inverse, #ffffff) !important;
}
.LTqnFyol70Gbv4 {
  min-width: 240px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 3px !important;
  background-color: var(--ds-background-input, #ffffff);
}
.czcc1BMT5zEKCm {
  border-color: var(--ds-border-selected, #0c66e4) !important;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.F1w_vkMQHx44pd {
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.F1w_vkMQHx44pd input {
  margin-bottom: 0;
  border: none !important;
  box-shadow: none !important;
  font-size: 13px;
  line-height: 19px;
}
.F1w_vkMQHx44pd input:focus {
  border: none !important;
  box-shadow: none !important;
}
.O2NwA7_5FslY5W {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.UzzDubNxmYbf__ {
  width: 420px;
}
.UzzDubNxmYbf__ .LTqnFyol70Gbv4 {
  height: 48px;
}
@media only screen and (max-width: 951px) {
  .UzzDubNxmYbf__ {
    width: 256px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchOption": `SHvlbAoTXLEUoP`,
	"searchResultIcon": `s00FC5WW2kgJuX`,
	"searchResultDetails": `SSF2Wm8KNx5F75`,
	"searchResultName": `zAAtIAmzhzCZbJ`,
	"searchResultOverview": `lTxCPJSvD119b1`,
	"searchOptionIsFocused": `SpyrBk9DQyDOXb`,
	"searchOptionIsSelected": `GFKWAI6QJVd94m`,
	"selectControl": `LTqnFyol70Gbv4`,
	"selectControlIsFocused": `czcc1BMT5zEKCm`,
	"searchInput": `F1w_vkMQHx44pd`,
	"searchPlaceholder": `O2NwA7_5FslY5W`,
	"large": `UzzDubNxmYbf__`
};
export default ___CSS_LOADER_EXPORT___;
